import React, { useState, useEffect, useContext } from "react";
import classNames from "classnames";
import { DashboardDrawer } from "../components/DashboardDrawer";
import NotificationPopover from "../components/NotificationPopover";
import UserProfilePopover from "../components/UserProfilePopover";
import HelpNavigation from "../components/HelpNavigation/HelpNavigation";
import CampaignList from "../components/CampaignList";
import styles from "./DashboardLayout.module.scss";
import AuthApi from "../context/AuthApi";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { getLocalValue } from "../utils/auth";
import {
  getHeaderDisplayRole,
  IsCampaignAdmin,
  IsCOEAdmin,
  IsCoach,
  IsCoachee,
} from "../config/Roles";

export function DashboardLayout({
  appBarContent,
  contentClass,
  isDisableCampaignSelection = false,
  isSessionScoped = false,
  ...props
}) {
  const Auth = useContext(AuthApi);
  const [drawerIsOpen, setDrawerIsOpen] = useState(true);
  const [anchorElNotification, setAnchorElNotification] = useState(null);
  const [anchorElUserProfile, setAnchorElUserProfile] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const notificationOpen = Boolean(anchorElNotification);
  const userProfileOpen = Boolean(anchorElUserProfile);

  const shouldShowCampaignSelection =
    (IsCampaignAdmin() || IsCOEAdmin()) && !isDisableCampaignSelection;

  useEffect(() => {
    const user = {
      fullName: getLocalValue("u_fullname"),
      userId: getLocalValue("employee_id"),
      role: getHeaderDisplayRole(),
    };
    setUserInfo(user);
  }, [Auth]);

  // open notification dialog
  const handleNotificationClick = event => {
    setAnchorElNotification(event.currentTarget);
  };

  // close notification dialog
  const handleNotificationClose = () => {
    setAnchorElNotification(null);
  };

  // open UserProfile dialog
  const handleUserProfileClick = event => {
    setAnchorElUserProfile(event.currentTarget);
  };

  // close UserProfile dialog
  const handleUserProfileClose = () => {
    setAnchorElUserProfile(null);
  };

  return (
    <div className={styles.layoutWrapper}>
      {(IsCoach() || IsCoachee()) && (
        <NotificationPopover
          open={notificationOpen}
          anchorEl={anchorElNotification}
          onClose={handleNotificationClose}
        />
      )}

      <UserProfilePopover
        open={userProfileOpen}
        anchorEl={anchorElUserProfile}
        onClose={handleUserProfileClose}
      />
      <div
        className={classNames(
          styles.appBar,
          drawerIsOpen ? styles.drawerIsOpen : ""
        )}
      >
        <div className={styles.appBarContent}>
          <div className={styles.appBarContentLeft}>
            {shouldShowCampaignSelection && (
              <div className={styles.campaignSelection}>
                <CampaignList isSessionScoped={isSessionScoped} />
              </div>
            )}
            {appBarContent}
          </div>
          <div className={styles.appBarContentRight}>
            <div className={styles.helpNavigationMenu}>
              <HelpNavigation />
            </div>
            {(IsCoach() || IsCoachee()) && (
              <div
                className={styles.notificationButton}
                onClick={handleNotificationClick}
              >
                <NotificationsNoneIcon color="inherit" />
              </div>
            )}
            <div
              className={styles.userDropdown}
              onClick={handleUserProfileClick}
            >
              {userInfo && (
                <>
                  <div className={styles.userDropdownContent}>
                    <div className={styles.userDropdownName}>
                      {userInfo.fullName}
                    </div>
                    <div className={styles.userDropdownID}>
                      ID{userInfo.userId}
                    </div>
                    {userInfo.role && (
                      <div className={styles.userDropdownRole}>
                        ROLE {userInfo.role}
                      </div>
                    )}
                  </div>
                </>
              )}

              <div className={styles.dropdownButton}>
                {anchorElUserProfile ? (
                  <KeyboardArrowUpIcon color="inherit" />
                ) : (
                  <KeyboardArrowDownIcon color="inherit" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <DashboardDrawer
        onClose={() => {
          setDrawerIsOpen(false);
          localStorage.setItem("drawerOpenState", false);
        }}
        open={drawerIsOpen}
      />
      <div
        className={classNames(
          styles.contentWrapper,
          drawerIsOpen ? styles.contentDrawerOpen : ""
        )}
      >
        {/* content */}
        <div className={classNames(styles.content, contentClass)}>
          {props.children}
        </div>

        {/* right sidebar content */}
        {props.rightSidebarContent ? (
          <div className={styles.rightSidebarContentWrapper}>
            <div className={styles.rightSidebarContent}>
              {props.rightSidebarContent}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
